module.exports = "pegasus/assets/theme2/medium/4.jpg";